export default __webpack_public_path__ + "static/media/cisco.2d82a092.svg";